/** 404. */
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg p-6 text-text">
      <div className="max-w-sm space-y-3 text-center">
        <h1 className="text-lg font-semibold">{t('notfound.title')}</h1>
        <p className="text-sm text-text-muted">{t('notfound.hint')}</p>
        <Button asChild variant="primary">
          <Link to="/projects">{t('notfound.home')}</Link>
        </Button>
      </div>
    </div>
  )
}
